import Flickity from "flickity";

export default function homeSlider({speed=6000}) {
  const imagesEl = document.querySelector(".home-slider");
  if (!imagesEl) return;

  const navEls = document.querySelectorAll(".home-slider-nav__item");

  const goToNextSlide = debounce(() => {
    imagesSlider.next(true);
  }, speed);

  const onSlideChange = (index) => {
    goToNextSlide();

    if (!index) index = 1;

    [...navEls].forEach((el, i) => {
      if (index === i) {
        return el.classList.add("is-active");
      }
      el.classList.remove("is-active");
    });
  };

  const imagesSlider = new Flickity(imagesEl, {
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    initialIndex: 1,
    on: {
      ready: () => {
        onSlideChange();
      },
    },
  });

  imagesSlider.on("select", (index) => {
    onSlideChange(index);
  });

  [...navEls].forEach((el, i) => {
    el.querySelector('.progress-line').style.transition = `transform ${speed}ms ease-out`;
    el.addEventListener("click", () => {
      imagesSlider.select(i);
    });
  });
}

function debounce(func, wait, immediate) {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}
